import { useEffect, useRef, useState } from 'react'
import { Alert } from 'avo-ui'
import icAlert from 'assets/images/ic-warning.svg'
import { UploadXLSXFile } from 'components/product/product-import/upload-xlsx-file/UploadXLSXFile'
import { API_PRODUCT_IMPORT } from 'services/apiProductImport'
import { downloadFile } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import moment from 'moment'

export const UploadXLSXFileContainer = ({ payload, setPayloadData, onChangeStep }) => {
    const uploadFileRef = useRef()
    const [isUpdate, setIsUpdate] = useState(false)
    const [isDragOver, setIsDragOver] = useState(false)
    const [sourceFile, setSourceFile] = useState({})
    const { fetching: downloadTemplate, isLoading } = useFetch(API_PRODUCT_IMPORT.DOWNLOAD_TEMPLATE)

    const onClickDownload = () => {
        downloadTemplate({}, '', {}, 'blob').then((response) =>
            downloadFile(null, response, `Template-Import-Product-${moment().format('DD-MM-YYYY')}.xlsx`),
        )
    }

    const cancelUploadFile = () => {
        setSourceFile({})
    }

    const onChangeUploadFile = (e) => {
        const allowedExtension = /(\.xlsx)$/i
        const sourceUploadFile = e.dataTransfer?.files[0] || e.target?.files[0]
        if (!allowedExtension.exec(sourceUploadFile?.name)) {
            Alert({
                icon: icAlert,
                title: 'Failed',
                message: 'Wrong Extension !!',
                autoClose: true,
                interval: 3000,
            })
        } else if (sourceUploadFile?.size > 64e6) {
            Alert({
                icon: icAlert,
                title: 'Failed',
                message: 'Invalid size !!',
                autoClose: true,
                interval: 3000,
            })
        } else {
            setSourceFile(sourceUploadFile)
        }
    }

    const onDragAndDrop = (e) => {
        e.preventDefault()
        const eventType = e?.type

        switch (eventType) {
            case 'drop':
                onChangeUploadFile(e)
                setIsDragOver(false)
                break
            case 'dragover':
                setIsDragOver(true)
                break
            default:
                setIsDragOver(false)
        }
    }

    const onChangeUpdate = ({ checked }) => {
        setIsUpdate(checked)
    }

    const onSubmitFile = () => {
        setPayloadData({ file: sourceFile, is_update: isUpdate, mapping_fields: [] })
        onChangeStep(2)
    }

    useEffect(() => {
        setSourceFile(payload?.file)
        setIsUpdate(payload?.is_update)
    }, [payload])

    const props = {
        uploadFileRef,
        isUpdate,
        isDragOver,
        isLoading,
        sourceFile,
        onClickDownload,
        cancelUploadFile,
        onChangeUploadFile,
        onDragAndDrop,
        onChangeUpdate,
        onSubmitFile,
    }

    return <UploadXLSXFile {...props} />
}
